import { render } from "./OrderFlow.vue?vue&type=template&id=864490b8"
import script from "./OrderFlow.vue?vue&type=script&lang=js"
export * from "./OrderFlow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__